/**
 * O MRR DE UM GRUPO, numa conta só.
 *
 * ⛔ Até 03/10/2026 havia dois cálculos: `montarGrupos` (grupoEconomico.ts, que
 * alimentava o cabeçalho de Grupos Econômicos) e `montarPainelDoGrupo`
 * (quemUsaQuemPaga.ts, da ficha, das listas e do painel). Davam o mesmo número
 * (685,30 e 1.118,00), mas por caminhos diferentes, e o primeiro ajuste feito num
 * só deles faria as telas discordarem. Os dois chamam esta função agora.
 *
 * O MRR do grupo é a soma do MRR das assinaturas ATIVAS das empresas do grupo.
 * Quem é membro é outra pergunta (rateio, parentClientId, local com CNPJ) e cada
 * chamador responde a dela; a conta do dinheiro é esta.
 */
export interface ContratoComMrr {
  clientId: number;
  status: string;
  mrr?: number | string | null;
}

/** MRR das assinaturas ativas de UMA empresa, em centavos exatos. */
export const mrrDaEmpresa = (contracts: ContratoComMrr[], clientId: number): number =>
  Math.round(contracts.filter((c) => c.clientId === clientId && c.status === 'Ativo').reduce((s, c) => s + (Number(c.mrr) || 0), 0) * 100) / 100;

/** MRR somado das empresas (cada uma conta uma vez, mesmo repetida na lista). */
export function mrrDasEmpresas(contracts: ContratoComMrr[], clientIds: Iterable<number>): number {
  const ids = Array.from(new Set(Array.from(clientIds)));
  return Math.round(ids.reduce((s, id) => s + mrrDaEmpresa(contracts, id), 0) * 100) / 100;
}
